<template>
  <div :class="['frame-a', { 'frame-a-expanded': photo },]">
    <video ref="video" :style="{ width: videoWidth }" autoplay></video>
 <div :class="['icon-a', { 'icon-a-closed': isPhotoClosed }]">
  <i class="fa fa-camera mb-3" @click="capturePhoto" id="btnCapture"></i>
  <i class="fa fa-times-circle text-danger" @click="close"></i>
  <i class="fa fa-play-circle text-success" @click="start"></i>
  <a v-if="photo" :href="photo" :download="props.dwnloadfileName + '.png'" id="linkAnchor" @click="reset">
    <i class="fa fa-download text-primary download-a"></i>
  </a>
</div>
    <canvas ref="canvas" style="display: none"></canvas>
    <div v-if="photo" class="photo-a">
     <img :src="photo" alt="Captured Snapshot" id="imgPhoto" v-if="photo" :class="isPhotoClosed ? 'imgPhoto-closed' : 'imgPhoto-default'" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineProps, defineExpose } from 'vue'
const video = ref(null)
const canvas = ref(null)
const photo = ref(null)
const videoWidth = ref("100%")
const isPhotoClosed = ref(false);
const props = defineProps({
    dwnloadfileName: {
    type: String,
    default: 'snapshot'
  },
    autoStart: {     
    type: Boolean,
    default: false
  }
})
const startCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
    })
    video.value.srcObject = stream
  } catch (error) {
    console.error("Error accessing camera:", error)
  }
}

const start = async () => {
  await startCamera()
    isPhotoClosed.value = false;
}
const close = () => {
  try {
    if (video.value?.srcObject) {
      const stream = video.value.srcObject;
      stream.getTracks().forEach(track => {
        track.stop();
      });

      video.value.srcObject = null;
      isPhotoClosed.value = true;
    }
  } catch (e) {
    console.error("Camera stop error:", e);
  }
};
const capturePhoto = () => {
  const videoElement = video.value
  const canvasElement = canvas.value
  const context = canvasElement.getContext("2d")

  canvasElement.width = videoElement.videoWidth
  canvasElement.height = videoElement.videoHeight
  context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height)

  photo.value = canvasElement.toDataURL("image/png")
  videoWidth.value = "45%"
}
const resetCamera = async () => {
  clearPhoto()
  if (video.value && video.value.srcObject) {
    const stream = video.value.srcObject
    stream.getTracks().forEach(track => track.stop())
    video.value.srcObject = null
    
  }
}

const reset = () => {
  setTimeout(() => {
    photo.value = null
    videoWidth.value = "100%"
    isPhotoClosed.value = false
  }, 100)
}
const clearPhoto = () => {
  photo.value = null
  videoWidth.value = "100%"
  isPhotoClosed.value = false
}
onMounted(() => {
    if (props.autoStart) {   
    startCamera()
  }
})
defineExpose({ startCamera, close, clearPhoto, resetCamera })
onBeforeUnmount(() => {
  if (video.value && video.value.srcObject) {
    const stream = video.value.srcObject
    stream.getTracks().forEach(track => track.stop())
    video.value.srcObject = null
  }
})
</script>
<style scoped>
.frame-a {
  width: 260px;
  height:235px;
  margin-left: -40px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}
.frame-a-expanded {
  width: 460px;
   height:205px;
}
.frame-a-expanded video {
  width: 45% !important;
}
.frame-a-expanded #btnCapture {
  width: 170px;

}
.frame-a-expanded .icon-a-closed {
  margin-top: 15px !important;

}
.icon-a-closed {
  margin-top: 40px !important;
}
.frame-a-expanded .imgPhoto-closed{
   width: 45%;
   margin-top: -235px;
   margin-left: 240px;
}
.icon-a {
  margin-top: 10px;
  display: flex;
  gap: 2px;
  align-items: center;
}

.icon-a i {
  font-size: 20px;
  cursor: pointer;
}
.imgPhoto-default {
  width: 45%;
 margin-top: -254px;
    margin-left: 239px;
}

.imgPhoto-closed {
   width: 45%;
   margin-top: -278px;
   margin-left: 250px;
}
.download-a {
  margin-left: 225px;
}

.photo-a a {
  display: inline-block;
  margin-top: 10px;
  font-size: 20px;
}

#btnCapture {
  width: 205px;
  height: 0px;
  font-size: 18px;
}
@media (max-width: 375px) {
  .frame-a-expanded {
   width: 260px;
  height:445px;
}
.imgPhoto-default {
  width: 100%;
 margin-top: 0px;
    margin-left: 0px;
}
.icon-a {
  margin-top: 0px;
  display: block;
  gap: 2px;
  align-items: center;
}
.frame-a-expanded .imgPhoto-closed{
   width: 100%;
   margin-top: 0px;
   margin-left: 0px;
}
.frame-a-expanded video {
  width: 100% !important;
}
}

</style>

